module.exports = "/_next/static/images/09442597ab6e34fd04422d381c951c50-phone-icon.svg";